class PasswordToggle extends HTMLElement {
  connectedCallback () {
    this.inputToggleButton = this.querySelector('[data-toggle-password]') || false
    this.inputToToggle = this.querySelector('input') || false
    this.displayedIcon = this.querySelector('[data-icon-displayed]') || false
    this.hiddenIcon = this.querySelector('[data-icon-hidden]') || false

    if (this.inputToToggle && this.inputToggleButton) {
      this.inputToggleButton.addEventListener('click', (event) => {
        this.togglePasswordVisibility(event)
      })
    } else {
      console.error('Missing toggle password visibility elements', {
        input: this.inputToToggle,
        'toggle button': this.inputToggleButton
      })
    }
  }

  togglePasswordVisibility (event) {
    event.preventDefault()
    const currentType = this.inputToToggle.getAttribute('type')
    this.inputToToggle.setAttribute('type', currentType === 'password' ? 'text' : 'password')
    this.displayedIcon.classList.toggle('hidden')
    this.hiddenIcon.classList.toggle('hidden')
  }
}

if (!customElements.get('password-toggle')) {
  customElements.define('password-toggle', PasswordToggle)
}
